import { setBeneficiaryDetails, setBeneficiaryImage, setBeneficiaryPregnancyHistory, setBenfDeathDetails, setHrpStatus, setIsHRP, setIsPregnant, setPregnancyDetails, setChildBenefList, updateChildDetails } from "@store/actions/beneficiaryAction";

const beneficiaryReduxStoreRemovalUtils = (dispatch: any) => {
    dispatch(setBeneficiaryDetails([]));
    dispatch(setBenfDeathDetails([]));
    dispatch(setBeneficiaryPregnancyHistory({}));
    dispatch(setIsHRP(false));
    dispatch(setIsPregnant(false));
    dispatch(setPregnancyDetails({}));
    dispatch(setHrpStatus({}));
    dispatch(setBeneficiaryImage({}));
    dispatch(updateChildDetails([]));
    dispatch(setChildBenefList([]));
};

export default beneficiaryReduxStoreRemovalUtils;